// Borda dos inputs mais forte que o padrão do Lara (surface.300).
// Usado no preset inicial (app.config.ts) e reaplicado pelo AppConfigurator, que recria o preset.
export const formFieldBorderPreset = {
    semantic: {
        colorScheme: {
            light: {
                formField: {
                    borderColor: '{surface.400}',
                    hoverBorderColor: '{surface.500}'
                }
            },
            dark: {
                formField: {
                    borderColor: '{surface.500}',
                    hoverBorderColor: '{surface.400}'
                }
            }
        }
    }
};
